import axios from 'axios';

import callApi from '../service/callApi';

export const getId8Image = (imageId) => {
  return callApi.request({
    url: `/api/id8/content/download?imageId=${imageId}`,
    method: 'GET',
    responseType: 'arraybuffer',
  });
};

export const getConsumerId8Image = (imageId, { projectName, projectPassword }) => {
  return axios.request({
    url: `/api/consumer/id8/content/download`,
    method: 'POST',
    responseType: 'arraybuffer',
    data: {
      projectRequest: {
        projectName,
        projectPassword,
      },
      request: imageId,
    },
  });
};

export const getSourceImage = (promptId) => {
  return callApi.request({
    url: `/api/id8/content/download/recreate/source/file?bucketId=${promptId}`,
    method: 'POST',
    responseType: 'arraybuffer',
  });
};

export const getConsumerSourceImage = (promptId, { projectName, projectPassword }) => {
  return callApi.request({
    url: `/api/consumer/id8/content/download/recreate/source/file?bucketId=${promptId}`,
    method: 'POST',
    responseType: 'arraybuffer',
    data: {
      projectName,
      projectPassword,
    },
  });
};

export const getDemoImage = (sessionId) => {
  return callApi.request({
    url: `/api/consumer/id8/demo/recreate/image?sessionId=${sessionId}`,
    method: 'GET',
    responseType: 'arraybuffer',
  });
};
